import { render } from "./StandardSeniorityAward.vue?vue&type=template&id=b4d7eb3e&scoped=true"
import script from "./StandardSeniorityAward.vue?vue&type=script&lang=js"
export * from "./StandardSeniorityAward.vue?vue&type=script&lang=js"

import "./StandardSeniorityAward.vue?vue&type=style&index=0&id=b4d7eb3e&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4d7eb3e"]])

export default __exports__